var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.siteWideSale || _vm.bannerCartMessage)?_c('div',{staticClass:"c-cart-messaging"},[_c('span',{staticClass:"u-sr-only"},[_vm._v(" Banner message: ")]),_vm._v(" "),_c('span',{attrs:{"aria-label":`${_vm.message}.`}},[_vm._v(" "+_vm._s(_vm.message)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }